import script from "./IndivAssetOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./IndivAssetOverview.vue?vue&type=script&setup=true&lang=js"

import "./IndivAssetOverview.vue?vue&type=style&index=0&id=235877a2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235877a2"]])

export default __exports__